module.exports = __webpack_public_path__ + "static/media/display-suite-09.a5546e93.jpg";